import React from 'react';
import { MainContainerLayout } from 'clorian-frontend-components';
import Configuration from '../components/configuration/Configuration';
import Header from '../components/structure/Header';
import Footer from '../components/structure/Footer';

const VerifierView = () => (
  <div>
    <Header />
    <MainContainerLayout>
      <Configuration />
    </MainContainerLayout>
    <Footer />
  </div>
);

export default VerifierView;
